import { type IngredientFragment } from "../../gql/generated/graphqlSchema.tsx";

type LabelItem = IngredientFragment["labelIngredients"][number];

export type FlatLabelRow = {
  readonly item: LabelItem;
  readonly depth: number;
  readonly order: string;
};

export const LABEL_INDENT_PX = 12;

export const flattenLabelRows = (items: readonly LabelItem[]): FlatLabelRow[] => {
  const byParent = new Map<string, LabelItem[]>();
  for (const item of items) {
    const key = item.parentId ?? "root";
    const list = byParent.get(key) ?? [];
    list.push(item);
    byParent.set(key, list);
  }

  const rows: FlatLabelRow[] = [];
  const walk = (parentKey: string, depth: number, prefix: string) => {
    const children = (byParent.get(parentKey) ?? []).sort((a, b) => a.sortOrder - b.sortOrder);
    children.forEach((item, i) => {
      const order = prefix ? `${prefix}.${i + 1}` : String(i + 1);
      rows.push({ item, depth, order });
      walk(item.id, depth + 1, order);
    });
  };
  walk("root", 0, "");
  return rows;
};
